// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gh-6";
export var emphasizeQuantity = "_gh-3";
export var flatBottomCorners = "_gh-5";
export var productImage = "_gh-0";
export var quantityContainer = "_gh-2";
export var tooltip = "_gh-1";
export var wrapAndEllipsesOverflow = "_gh-4";